<template>
    <b-container class="browse mx-auto bg-white rounded p-3 mt-5 container">
        <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
        <b-row>
            <b-col md="8" offset-md="2" class="text-center">
                <h4>Meet the Team</h4>
                <hr>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-md-10 offset-md-1">
                <vue-chunks id="agents" ref="test" :items="this.agents" :columns="3" chunk-class="row mb-3"
                            item-class="col-4">
                    <template slot-scope="slot">
                        <a v-if="slot.item.user" :href="'/' + slot.item.slug" target="_blank">
                            <b-img class="rounded-circle img-fluid d-block mx-auto" :src="slot.item.image_url !== null ? slot.item.image_url + '?fit=facearea&facepad=6&w=250&h=250' :
                                'http://forman-realty-group.imgix.net/no_image_available.jpg?fit=facearea&facepad=6&w=250&h=250'"></b-img>
                            <h5 class="agent_name"> {{slot.item.user.name}} </h5>
                        </a>
                    </template>
                </vue-chunks>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-md-12">
                <b-pagination
                    v-model="pagination.current_page"
                    :total-rows="total"
                    align="center"
                    :per-page="per_page"
                    aria-controls="results"
                ></b-pagination>
            </b-col>
        </b-row>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i style="color: gray" class="fas fa-circle-notch fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </b-container>
</template>

<script>
export default {
    name: 'about',

    data() {
        return {
            breadcrumb_items: [],
            agents: [],
            perPage: 25,
            pagination: {
                current_page: 1,
                total: null,
                from: null,
                per_page: 24
            },
            isLoading: false
        }
    },
    created () {
        this.getAgentData();
    },
    methods: {
        getAgentData() {
            let _self = this;
            _self.isLoading = true;

            let data = {
                page: _self.current_page,
                sortOrder: "ASC"
            };

            let promise = axios.post('/api/agents',data);
            // Must return a promise that resolves to an array of items
            return promise.then((response) => {

                if(typeof response !== 'undefined' && response !== null) {
                    _self.agents = Array.from(response.data.agents);

                    _self.pagination = response.data.pagination;
                    _self.breadcrumb_items = response.data.breadcrumbs;
                    _self.isLoading = false;
                }
            });
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        }
    },
    mounted() {
        // Set the initial number of items
        this.$eventHub.$on('login::success', this.logged_in);
    },
    computed: {
        total() {
            return this.pagination.total
        },
        current_page() {
            return this.pagination.current_page
        },
        per_page() {
            return this.pagination.per_page
        }
    },
    watch: {
        current_page: function () {
            this.getAgentData();
        }
    }
}

</script>

<style lang="scss">
.clear {
    color: gray;
}

i:hover:before {
    height: 42px;
    color: deeppink;
}

.criteria {
    font-size: small;

    .button {
        color: gray;
    }
}

#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

.no-border {
    border: 0;
}

.wrapper {
    position: relative;
}

.wrapper span.fas {
    position: absolute;
    top: 20px;
    left: 20px;
    color: white;
    box-shadow: 0 0 5px 5px #000;
}

.agent_name {
    text-align: center;
    color: black;
}
</style>
